<template>
    <e-iframe-page :loading="loading" ref="iframePage" :title="'Create Website|Créer un site' | tr"
        class="mx-auto text-left" style="max-width: 600px;">
        <template v-if="newWebsite">
            <tab-header v-model="newWebsite.name" :icon="getPublicIcon('window')">
                <template #input>
                    <b-form-group class="ml-3" :label="'Website Name|Nom du site internet' | tr">
                        <e-input type="name" v-model="newWebsite.name" />
                        <div class="form-help mt-2" v-tr>
                            Name is for internal use only|Le nom du site est pour usage interne seulement
                        </div>
                    </b-form-group>
                </template>
            </tab-header>

            <!--                        <b-form-group :disabled="!dealerIds || dealerIds.length <= 1">-->
            <!--                            <label v-tr>Venue (required)|Compte (requis)</label>-->
            <!--                            <vue-multiselect v-model="newWebsite.dealerid" placeholder="Choose a dealer" :allowEmpty="false"-->
            <!--                                             :options="dealerIds">-->
            <!--                            </vue-multiselect>-->
            <!--                        </b-form-group>-->

            <b-card class="simple mt-3" style="overflow: visible !important">
                <b-form-group :label="'Languages|Langues' | tr">
                    <e-treeselect v-model="selectedLanguages" :options="supportedLocalesList" track-by="locale"
                        label="name" multiple :flat="true" :close-on-select="false" :clearable="false"
                        prepend-icon="fas fa-language" :placeholder="'Select languages|Sélectionnez les langues' | tr"
                        variant="simple">
                        <template #option-label="{ node }">
                            <div class="d-flex align-items-center">
                                <img :src="node.flag" class="flag-icon mr-2" />
                                <span>{{ node.name }}</span>
                            </div>
                        </template>
                        <template #selected-pill-label="{ node }">
                            <div class="d-flex align-items-center">
                                <img :src="node.flag" class="flag-icon mr-2" />
                                <span>{{ node.name }}</span>
                            </div>
                        </template>
                    </e-treeselect>
                    <div class="form-help mt-2" v-tr>
                        The languages selected here will be available when editing content|Les langues selectionnees ici seront disponibles lors de l'edition du contenu
                    </div>
                </b-form-group>
            </b-card>

            <b-card class="simple mt-3">
                <b-form-group :label="'Site Title|Titre du site' | tr">
                    <e-translation-input v-model="newWebsite.meta.title"
                        :locales-prop="selectedLanguages.map(l => l.locale)" :use-locales="cmsLocales" />
                    <div class="form-help mt-2" v-tr>
                        Your site title appears in your browser tab, along with your favicon.|
                        Le titre de votre site apparaît dans l'onglet du navigateur, à côté du favicon.
                    </div>
                </b-form-group>

                <b-form-group :label="'Domain Name|Nom de domaine' | tr">
                    <b-input-group>
                        <b-input-group-text>https://</b-input-group-text>
                        <e-input type="text" v-model="newWebsite.domain" />
                    </b-input-group>
                </b-form-group>
            </b-card>
        </template>

        <template #footer>
            <b-btn variant="primary" @click="create()" :disabled="!isValid">
                <span v-tr>Create|Créer</span>
            </b-btn>
        </template>
    </e-iframe-page>
</template>

<script>
import SelectCmsItemType from "@/components/editor/properties/inputs/select-cms-item-type.vue";
import CmsPage from "@/helpers/cms/CmsPage.js";
import TabHeader from "@/layout/tab-header.vue";
import NetworkV2 from "@vue-components/helpers/NetworkV2.js";
import ETranslationInput from "@vue-components/components/e-translation-input.vue";
import ETreeselect from "@vue-components/components/e-treeselect.vue";
import { getSupportedLocales, getFallbackLang, getLangFromLocale, getLangsFromLocales } from "@vue-components/helpers/I18nPluginHelper.js";
import EIframePage from "@vue-components/components/e-iframe-page.vue";
import NewWebsiteTemplate from "@/assets/json/new-website-template.json"
import EInput from "@vue-components/components/e-input.vue";

// iframe-website-creation #hot-reload-debug
export default {
    name: `iframe-website-creation`,
    components: { EInput, SelectCmsItemType, ETranslationInput, TabHeader, EIframePage, ETreeselect },
    data() {
        return {
            loading: false,
            newWebsite: null,
            homePage: null
        }
    },
    computed: {
        isValid() {
            if (!this.newWebsite)
                return false;

            return (this.newWebsite.name && this.newWebsite.domain);
        },
        dealerIds() {
            return this.$store.state.dealers.map(dealer => {
                return dealer.dealerid;
            });
        },
        selectedLanguages: {
            get() {
                const websiteLangs = this.newWebsite.settings.languages;

                if (websiteLangs.length) {
                    return getLangsFromLocales(websiteLangs);
                }

                return [getFallbackLang()];
            },
            set(value) {
                this.newWebsite.settings.languages = value.map(lang => lang.locale);
            }
        },
        supportedLocalesList() {
            return getSupportedLocales();
        },
        cmsLocales() {
            return this.newWebsite?.settings?.languages || [];
        }
    },
    mounted() {
        this.newWebsite = clone(NewWebsiteTemplate);
        this.newWebsite.dealerid = this.$route.params.dealerid;

        this.homePage = new CmsPage();
        this.homePage.name = { en: `Home`, fr: `Accueil` };
        this.homePage.permalink = { en: `/`, fr: `/` };
        this.homePage.glyph = `fa-house`;
        this.homePage.homePage = true;
        this.homePage.dealerid = this.newWebsite.dealerid;
    },
    methods: {
        create() {
            if (!this.isValid) {
                this.showInvalidFields();
                return false;
            }
            this.showLoading();

            NetworkV2.post(`/api/websites/create`, {
                website: this.newWebsite,
                home: this.homePage
            })
                .then(resp => {
                    this.showSavedMessage(`Created|Créé`, `Website created successfully|Site internet créé avec succès`);

                    this.$refs.iframePage.created(resp.data);
                });
        }
    }
}
</script>

<style scoped>
.flag-icon {
    width: 20px;
    height: 14px;
    object-fit: contain;
}
</style>
